import PropTypes from 'prop-types'
import { Box, IconButton } from '@mui/material'

import { ReactComponent as ArrowLineLeft } from '../../../assets/icons/arrow-line-left.svg'
import { ReactComponent as ArrowLineRight } from '../../../assets/icons/arrow-line-right.svg'
import { ReactComponent as CaretLeft } from '../../../assets/icons/caret-left.svg'
import { ReactComponent as CaretRight } from '../../../assets/icons/caret-right.svg'

const ICON_PROPS = {
  size: 16,
  weight: 'regular',
}

const PaginationActions = ({ count, page, rowsPerPage, onPageChange }) => {
  const handleFirstPageButtonClick = event => {
    onPageChange({ ...event, paginationAction: 'first' }, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange({ ...event, paginationAction: 'previous' }, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange({ ...event, paginationAction: 'next' }, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(
      { ...event, paginationAction: 'last' },
      Math.max(0, Math.ceil(count / rowsPerPage) - 1),
    )
  }

  return (
    <Box display="flex">
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
        size="large"
      >
        <ArrowLineLeft {...ICON_PROPS} />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        size="large"
      >
        <CaretLeft {...ICON_PROPS} />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
        size="large"
      >
        <CaretRight {...ICON_PROPS} />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
        size="large"
      >
        <ArrowLineRight {...ICON_PROPS} />
      </IconButton>
    </Box>
  )
}

PaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
}

export default PaginationActions
